// removed by extract-text-webpack-plugin
module.exports = {"downloadBar":"downloadBar_1yRqX","closeImg":"closeImg_39bH3","logoImg":"logoImg_JrLKa","downloadTitle":"downloadTitle_2uXqG","downloadLabel":"downloadLabel_3KZxW"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/HomeLayout/index.scss
// module id = 148
// module chunks = 15